import { Popover, Text, Icon } from "@amzn/storm-ui";
import { link } from "@amzn/storm-ui-icons";
import React, { useState } from "react";
import styled from "styled-components";

const StyledIconWrapper = styled.div<{ $disabled?: boolean }>`
    display: inline-flex;
    align-items: center;
    margin: 0 8px;
    cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
    opacity: ${(props) => (props.$disabled ? "0.5" : "1")};

    &:hover {
        opacity: ${(props) => (props.$disabled ? "0.5" : "0.8")};
    }
`;

const PopperContent = styled.div`
    padding: 12px;
    max-width: 300px;
`;

interface ShareIconProps {
    onClick: () => void;
    tooltipMessage: string;
    disabled?: boolean;
    testId?: string;
}

export const ShareIcon: React.FC<ShareIconProps> = ({
    onClick,
    tooltipMessage,
    disabled = false,
    testId = "share-insight-icon",
}) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        onClick();
    };

    const trigger = (
        <StyledIconWrapper
            onClick={handleClick}
            $disabled={disabled}
            onMouseEnter={() => !disabled && setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            data-testid={testId}
        >
            <Icon type={link} size="small" data-testid={`${testId}-svg`} />
        </StyledIconWrapper>
    );

    return (
        <Popover
            id={`${testId}-popper`}
            isOpen={showTooltip}
            trigger={trigger}
            withCloseButton={false}
            autoFocus={false}
            disablePortal={true}
            focusableBody={false}
            position="top"
            strategy="absolute"
            spacing={0}
        >
            <PopperContent>
                <Text>{tooltipMessage}</Text>
            </PopperContent>
        </Popover>
    );
};
